import {
  type ViewportToolDefinition,
  type ViewportToolsetDefinition,
  type ViewportToolsetId,
} from "@/viewport-tools/core";
import { VIEWPORT_TOOLSET_PLUGINS } from "@/viewport-tools/plugins";

export const VIEWPORT_TOOLSET_DEFINITIONS: ViewportToolsetDefinition[] =
  VIEWPORT_TOOLSET_PLUGINS.map((plugin) => plugin.toolset);

export const VIEWPORT_TOOL_DEFINITIONS: ViewportToolDefinition[] =
  VIEWPORT_TOOLSET_PLUGINS.flatMap((plugin) => plugin.getTools());

export function getViewportToolsetDefinition(
  toolsetId: ViewportToolsetId
): ViewportToolsetDefinition | undefined {
  return VIEWPORT_TOOLSET_DEFINITIONS.find((toolset) => toolset.id === toolsetId);
}

export function getViewportToolDefinitionsByToolset(
  toolsetId: ViewportToolsetId
): ViewportToolDefinition[] {
  return VIEWPORT_TOOL_DEFINITIONS.filter((tool) => tool.toolsetId === toolsetId);
}
